import { useQuery } from "@tanstack/react-query";
import { ONE_MINUTE_MS } from "../utils/time";
import { QUERY_KEYS } from "./constants";
import { usePortalApiClient } from "./usePortalApiClient";
export function useAssetsUsdConversion(useQueryOptions = {}) {
    const portalApiClient = usePortalApiClient();
    return useQuery({
        queryKey: [QUERY_KEYS.ASSETS_USD_CONVERSION],
        queryFn: async () => {
            const { currentUsdPerBtc, currentUsdPerEth } = await portalApiClient.getPortalStatistics();
            return {
                btcUsd: currentUsdPerBtc,
                ethUsd: currentUsdPerEth,
            };
        },
        staleTime: 30 * ONE_MINUTE_MS,
        retry: 1,
        ...useQueryOptions,
    });
}
//# sourceMappingURL=useAssetsUSDConversion.js.map